import React from 'react';
import type { PreventionAlert } from 'types/preventionAlerts';
import { AlertItem } from './AlertItem';
import { Row, RowActions, RowBody, RowMain, RowName } from './DuePreventionsSection.styles';

interface PreventionRowProps {
  alert: PreventionAlert;
  name: string;
  children?: React.ReactNode;
  actions?: React.ReactNode;
}

export const PreventionRow: React.FC<PreventionRowProps> = ({ alert, name, children, actions }) => {
  return (
    <Row>
      <AlertItem alert={alert} stacked />
      <RowMain>
        <RowBody>
          <RowName>{name}</RowName>
          {children}
        </RowBody>
        {actions && <RowActions>{actions}</RowActions>}
      </RowMain>
    </Row>
  );
};
